import { restClient } from '@/Core'

import { toNode } from '../Helpers/diskResponse'
import { DISK_UPLOAD_REQUEST_TIMEOUT_MS } from './UploadDiskFileTask'

import type { DiskNode } from '../Contracts/DiskNode'

/**
 * Завершити сесію: `POST /services/disk/uploads/{uuid}/complete`. Бек склеює
 * шматки, звіряє sha256 і створює файл чи нову версію — для великого файлу
 * це довше за типові 30 с клієнта.
 */
export const CompleteDiskUploadTask = async (uuid: string): Promise<DiskNode> => {
    const response = (await restClient.post(`/services/disk/uploads/${encodeURIComponent(uuid)}/complete`, {
        timeout: DISK_UPLOAD_REQUEST_TIMEOUT_MS,
    })) as unknown

    return toNode(response)
}
